import { objectOf, arrayOf, maybe, enumOf } from "@altostra/type-validations";
import { string, any } from "@altostra/type-validations/lib/primitives";

import type { SegmentCohortsExecuteSqlPreviewResult, SegmentCohortsSqlPreviewStatus } from "./types";

export const isSegmentCohortsExecuteSqlPreviewResult = objectOf<SegmentCohortsExecuteSqlPreviewResult>({
  status: enumOf<SegmentCohortsSqlPreviewStatus>("success", "invalid", "pending"),
  error_message: maybe(string),
  query_id: maybe(string),
});

export const isSegmentCohortsGetSqlPreviewResult = objectOf({
  results: arrayOf(any),
});
